import { useLazyQuery } from '@apollo/client';
import type { AudienceSegmentExcelGenerateInputSegmentData } from '@openx/types/gqlTypes';
import { useCallback } from 'react';
import { GetAudienceSegmentExcelGenerateDocument } from '../../../graphql/query/dealPrompt/GetAudienceSegmentExcelGenerate.generated';

export const useDealPromptAudienceExcelGenerate = () => {
  const [fetchAudienceSegmentExcelGenerate] = useLazyQuery(GetAudienceSegmentExcelGenerateDocument);

  const fetchDealPromptAudienceExcelGenerate = useCallback(
    async (
      { segmentData }: { segmentData: AudienceSegmentExcelGenerateInputSegmentData },
      abortSignal?: AbortSignal
    ) => {
      const result = await fetchAudienceSegmentExcelGenerate({
        variables: {
          input: {
            segmentData,
          },
        },
        context: {
          fetchOptions: {
            signal: abortSignal,
          },
        },
      });
      return {
        fileData: result?.data?.audienceSegmentExcelGenerate?.fileData ?? '',
        _error: result?.error,
      };
    },
    [fetchAudienceSegmentExcelGenerate]
  );

  return {
    fetchDealPromptAudienceExcelGenerate,
  };
};
